<div class="dialog">
    <div class="dialog-header">
        上传线下案卷
    </div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 案卷文件
                </div>
                <div class="column background-module" [style.width]="500 + 'px'">
                    <format-data [contentStr]="pdfName" [patternStr]="'E+500'">
                    </format-data>
                </div>
                <div class="column background-module" [style.width]="100 + 'px'">
                    <button class="color-white" nz-button nzType="primary">浏览
                        <input type="file" [accept]="pdf" (change)="onFileSelected($event, pdf)" />
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 案卷目录
                </div>
                <div class="column background-module" [style.width]="500 + 'px'">
                    <format-data [contentStr]="excelName" [patternStr]="'E+500'">
                    </format-data>
                </div>
                <div class="column background-module" [style.width]="100 + 'px'">
                    <button class="color-white" nz-button nzType="primary">浏览
                        <input type="file" [accept]="excel" (change)="onFileSelected($event, excel)" />
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()">同步</button>
    </div>
</div>